/** "5:00 AM–6:00 AM" for slot 5; slot 0 is "12:00 AM–1:00 AM" and slot 23 is "11:00 PM–12:00 AM". Same wording as the server (core/timezone.js). */
export function reviewSlotLabel(hour: number): string {
  const fmt = (h: number) => `${((h + 11) % 12) + 1}:00 ${h % 24 < 12 ? 'AM' : 'PM'}`;
  return `${fmt(hour)}–${fmt((hour + 1) % 24)}`;
}

export const REVIEW_SLOTS = Array.from({ length: 24 }, (_, hour) => ({ value: String(hour), label: reviewSlotLabel(hour) }));

/** An instant written in the COMPANY's zone ("Thu, Oct 22, 5:00 AM CDT"), never the browser's. */
export function formatInZone(iso: string, timeZone: string): string {
  return new Date(iso).toLocaleString('en-US', { timeZone, weekday: 'short', month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit', timeZoneName: 'short' });
}
